<template>
  <div
    v-if="data && $login.can('channels.view')"
    class="mb-3"
  >
    <page-header :header="data.name">
      <router-link
        v-if="$login.can('analysts.create')"
        :to="{ name: 'analysts.create', query: { channel_id: data.id } }"
        class="btn btn-primary"
      >
        Add Analyst
      </router-link>
    </page-header>
    <tabs ref="tabs">
      <!-- Analytics tab -->
      <tab name="Analytics">
        <analytics :data="data" />
      </tab>

      <tab name="Details">
        <div :data="data">
          <channel-form
            ref="form"
            class="pt-3"
            v-model="data"
            v-if="canEdit"
            @save-success="saveSuccess"
          />
          <read-only
            v-else
            :channel="data"
          />
        </div>
      </tab>

      <tab name="Analysts">
        <analysts
          :channel="data"
        />
      </tab>

      <tab name="Coverage">
        <coverage
          :channel="data"
        />
      </tab>
    </tabs>
  </div>
</template>

<script>
import ChannelForm from './Form'
import axios from '@/axios'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'
import Analytics from './Analytics'
import Analysts from './Analysts'
import Coverage from './Coverage'
import ReadOnly from './ReadOnly'
import {successNotification} from '@/notifications'

export default {
  components: {
    ChannelForm,
    Tabs,
    Tab,
    Analytics,
    Coverage,
    Analysts,
    ReadOnly,
  },

  metaInfo () {
    return {
      title: this.data ? this.data.name : 'View Channel',
    }
  },

  data () {
    return {
      data: null,
      loading: false,
    }
  },

  computed: {
    canEdit () {
      return this.$login.can('channels.update')
    },
  },

  created () {
    this.getChannel()
  },

  methods: {
    async getChannel () {
      const {channelId} = this.$route.params
      const {data} = await axios.get('/channels/' + channelId, {
        params: {
          populate: [
            'analysts',
            'default_address',
            'countries',
            'socialLinks',
            'sectors',
          ],
        },
      })

      this.data = data.data
    },

    saveSuccess () {
      this.$notify(successNotification())
    },

    addAnalyst () {
      this.$refs.tabs.activateTab('Analysts')
      this.$nextTick(() => {
        this.$modal.show('add-analyst')
      })
    },

  },
}
</script>
